module.exports = "<section class=\"container-fluid with-maxwidth chapter\">\r\n    <BalanceGeneral-consultar></BalanceGeneral-consultar>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Contabilidad/balanceGeneral/balanceGeneral.component.html
// module id = ./src/app/Contabilidad/balanceGeneral/balanceGeneral.component.html
// module chunks = main